module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container checkout"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('share-story', {
    attrs: {
      "hr": "below",
      "order": _vm.orderId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Order Summary")]), _vm._v(" "), _c('div', [_vm._m(1), _vm._v(" "), _vm._l((_vm.cart), function(item, itemIndex) {
    return _c('div', {
      staticClass: "tb"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [_c('div', {
      staticClass: "prod-container"
    }, [(item.gc) ? _c('img', {
      staticClass: "prod-img",
      attrs: {
        "src": "images/giftcertificate.png"
      }
    }) : [_c('img', {
      staticClass: "prod-img",
      attrs: {
        "src": 'images/catalog/' + _vm.campaign.short_url + '/' + _vm.products[item.item_id].item_image_blank
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "prod-replica cart-img"
    }, [_c('div', {
      staticClass: "prod-replica-table"
    }, [_c('div', {
      staticClass: "prod-replica-table-td vb"
    }, _vm._l((_vm.products[item.item_id].max_lines), function(n) {
      return _c('p', [_vm._v(_vm._s(item.lines[n - 1]))])
    }), 0)])])]], 2)]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-9"
    }, [(item.gc) ? [(itemIndex in _vm.shipItemTo && 'qtys' in _vm.shipItemTo[itemIndex]) ? [_vm._l((_vm.shipItemTo[itemIndex].qtys), function(qty, qtyIndex) {
      return _c('div', {
        staticClass: "row tr"
      }, [_vm._m(2, true), _vm._v(" "), _c('div', {
        staticClass: "col-xs-4 col-md-4",
        domProps: {
          "innerHTML": _vm._s(_vm.products[item.item_id].description + ' GIFT CERTIFICATE')
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "col-xs-7 col-md-7"
      }, [_vm._v("\n                                                        " + _vm._s(_vm._f("addressToString")(_vm.addresses[qty.address_id])) + "\n                                                    ")])])
    }), _vm._v(" "), _vm._l((_vm.cart[itemIndex].children), function(qty, childId) {
      return _c('div', {
        staticClass: "row tr"
      }, [(qty > 0) ? [_c('div', {
        staticClass: "col-xs-1 text-center"
      }, [_c('div', {
        staticClass: "wrap-count"
      }, [_c('div', {
        staticClass: "amount"
      }, [_c('span', [_vm._v(_vm._s(qty))])])])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-4 col-md-4",
        domProps: {
          "innerHTML": _vm._s(_vm.baseProductChildren[childId].description)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "col-xs-7 col-md-7"
      })] : _vm._e()], 2)
    })] : _vm._e()] : [_c('div', {
      staticClass: "row tr"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-md-4",
      domProps: {
        "innerHTML": _vm._s(_vm.products[item.item_id].description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-md-7"
    })]), _vm._v(" "), (itemIndex in _vm.shipItemTo && 'qtys' in _vm.shipItemTo[itemIndex]) ? _vm._l((_vm.shipItemTo[itemIndex].qtys), function(qty, qtyIndex) {
      return _c('div', {
        staticClass: "row tr"
      }, [_vm._m(4, true), _vm._v(" "), _c('div', {
        staticClass: "col-xs-4 col-md-4",
        domProps: {
          "innerHTML": _vm._s(_vm.baseProductChildren[qty.item_id].description)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "col-xs-7 col-md-7"
      }, [_vm._v("\n                                                        " + _vm._s(_vm._f("addressToString")(_vm.addresses[qty.address_id])) + "\n                                                    ")])])
    }) : _vm._e()]], 2)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("Subtotal:\n                                    "), _c('span', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("$ ")]), _vm._v(_vm._s(_vm.subTotal.toFixed(2)) + "\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [_vm._v("Sales Tax:\n                                    "), _c('span', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("$ ")]), _vm._v(_vm._s(_vm.salesTax.toFixed(2)) + "\n                                    ")])]), _vm._v(" "), (_vm.isConvenienceFeeAllowed) ? _c('div', {
    staticClass: "total"
  }, [_vm._v("Web Convenience Fee:\n                                    "), _c('span', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("$ ")]), _vm._v(_vm._s(_vm.convenienceFee.toFixed(2)) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), _c('strong', {
    staticClass: "subtotal"
  }, [_vm._v("Order Total:\n                                    "), _c('span', [_vm._v("$ ")]), _vm._v(_vm._s(_vm.orderTotal.toFixed(2)) + "\n                                ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Order Confirmation")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Please note: you will receive an email order confirmation detailing your order and important review instructions.\n                                    This will be in your email. We recommend checking your spam or junk folder if this is your first time ordering.\n                                ")]), _vm._v(" "), _c('p', [_vm._v("The location of all engraved bricks will be determined at the discretion of D.C. United.")]), _vm._v(" "), _c('p', [_vm._v("Please print for your records.")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-danger btn-lg",
    on: {
      "click": _vm.onPrintReceipt
    }
  }, [_vm._v("Print Receipt")])])], 2)])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "mt-10"
  }, [_c('strong', [_vm._v("Thank you for becoming a part of D.C. United history and congratulations on commemorating your legacy with a brick in the Audi Field Fanwalk!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th hidden-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_vm._v("PRODUCT")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-1 text-center"
  }, [_vm._v("QTY")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-md-4"
  }, [_vm._v("DESCRIPTION")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-md-7"
  }, [_vm._v("SHIPPING ADDRESS (if applicable)")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1 text-center"
  }, [_c('div', {
    staticClass: "wrap-count"
  }, [_c('div', {
    staticClass: "amount"
  }, [_c('span', [_vm._v("1")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1 text-center"
  }, [_c('div', {
    staticClass: "wrap-count"
  }, [_c('div', {
    staticClass: "amount"
  }, [_c('span', [_vm._v("1")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1 text-center"
  }, [_c('div', {
    staticClass: "wrap-count"
  }, [_c('div', {
    staticClass: "amount"
  }, [_c('span', [_vm._v("1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6698c46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confirmation.vue
// module id = R5o+
// module chunks = 1